import { Suspense } from 'react'
import { LazyLoadWrapper } from '../LazyLoadWrapper'
import { DataTableLoading, DataTableComponent } from './'

interface LazyDataTableComponentProps {
  id: string
}

/**
 * A wrapper around DataTableComponent that only fetches data when the component is visible
 * or about to become visible in the viewport
 */
export function LazyDataTableComponent({ id }: LazyDataTableComponentProps) {
  return (
    <LazyLoadWrapper
      placeholder={<DataTableLoading />}
      triggerOffset="300px" // Start loading when within 300px of viewport
      toggleOnVisibility
    >
      <Suspense fallback={<DataTableLoading />}>
        <DataTableComponent id={id} />
      </Suspense>
    </LazyLoadWrapper>
  )
}
